
import React, { Component, Fragment } from 'react';
import ConfirmationPopup from 'Components/ConfirmationPopup';

export default class WithDrawBid extends Component {
    constructor(props) {
       super(props);
       this.state={
         isShowWithDraw: this.props.isShowWithDraw,
         isRfqTypeLtc: this.props.rfqTypeLtc
       }
    }
  
    withDrawBid = (e) => {
       this.setState({
         isShowWithDraw: true
       })
     
    }

    isHideWithDrawBid=(e)=>{
      if (e && e.preventDefault && e.stopPropagation) {
            e.stopPropagation();
            e.preventDefault();
          }
      this.setState({
         isShowWithDraw: false
      })
    };

    isWithDrawConfirmation =(e)=>{
      const { tripId , rfqId} = this.props;
        const data = {
         trip_id: tripId,
         rfq_id : rfqId
      }
      if (e && e.preventDefault && e.stopPropagation) {
         e.stopPropagation();
         e.preventDefault();
      }
      this.props.withDrawBid(data);
      this.setState({
         isShowWithDraw: false
      })
    }

    render() {
        const {isRfqTypeLtc, isShowWithDraw} = this.state;
       return (
       <div className="fBold theme-color tCenter fs-14 curP pr ml-5 col-1" onClick={(e) => this.withDrawBid(e)}>
                      Withdraw Bid
         {isShowWithDraw &&  <ConfirmationPopup text={'Are You Sure You Want To Withdraw Bid?'}  onCancel={this.isHideWithDrawBid} onConfirm={this.isWithDrawConfirmation} />}
        </div>
       )
    }
 }